<template>
    <div class="modal-card card">
        <form @submit.prevent="onCopy()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Duplicate Tag Template</h4>
                <!-- Close -->
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div class="card-body">
                <p class="text-muted">
                    A copy of <b>{{ sourceName }}</b> will be created in this client's library.
                </p>
                <div class="mb-3">
                    <label for="copyTagTemplateName" class="form-label">New Template Name</label>
                    <input
                        id="copyTagTemplateName"
                        class="form-control"
                        type="text"
                        v-model.trim="newName"
                        placeholder="Name for the new tag template"
                        autocomplete="off"
                    />
                </div>
                <div v-if="error" class="text-danger">
                    {{ error }}
                </div>
            </div>
            <div class="card-footer text-end">
                <button type="button" data-bs-dismiss="modal" class="btn btn-secondary" aria-label="Close">
                    Cancel
                </button>&nbsp;
                <button class="btn btn-primary" :disabled="!newName || loading">
                    <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>Duplicate</div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { isDuplicate } from "../../utils/commonFunction";

export default {
    name: "CopyTagTemplate",
    props: {
        modalData: {
            type: Object,
        },
    },
    data() {
        return {
            sourceName: this.modalData.name,
            newName: `${this.modalData.name}_copy`,
            error: "",
            loading: false,
        };
    },
    methods: {
        ...mapActions("aut", {
            copyTagTemplate: "copyTagTemplate",
            fetchTagTemplates: "fetchTagTemplates",
        }),
        async onCopy() {
            this.error = "";
            this.loading = true;
            try {
                if (!this.$store.state.aut.tagTemplates.length) {
                    await this.fetchTagTemplates();
                }
                if (isDuplicate(this.newName, this.$store.state.aut.tagTemplates, "name", null)) {
                    this.error = `A tag template named '${this.newName}' already exists.`;
                    return;
                }
                await this.copyTagTemplate({ name: this.sourceName, newName: this.newName });
            } catch (error) {
                this.error = error.response && error.response.data && error.response.data.error
                    ? error.response.data.error
                    : error.message;
                return;
            } finally {
                this.loading = false;
            }
            this.$store.dispatch("hideModal");
            this.$store.dispatch("addToast", {
                message: "Tag template duplicated successfully.",
                type: "success",
            });
            this.$store.dispatch("aut/fetchTagTemplates");
            //Note: drop the user straight into the new template so they can keep editing.
            this.$router.push(`/${this.$store.state.currentClient.cid}/aut/tag-templates/${encodeURIComponent(this.newName)}`);
        },
    },
};
</script>

<style>
</style>
